import AdvertisersContainer from 'modules/advertisers/containers/AdvertisersContainer';

const AdvertisersView = props => <AdvertisersContainer {...props} />;

export default AdvertisersView;
